const icon = new URL('../../icons/light.png', import.meta.url).href

export default {
  type: 'light',
  description: 'Light',
  group: '3D' /* line|shape|textAndMedia|chartAndGauge|table|container|dataSource|IoT|3D|warehouse|form|etc */,
  icon,
  model: {
    type: 'light',
    rx: 10,
    ry: 10,
    cx: 150,
    cy: 150,
    zPos: 1000,
    fillStyle: '#fff',
    strokeStyle: '#000',
    alpha: 1,
    hidden: false,
    lineWidth: 1,
    lineDash: 'solid',
    lineCap: 'butt'
  }
}
